import React from 'react';
import {
  Box, Button,
  Card,
  Container,
  Divider,
  Grid,
  Typography
} from '@material-ui/core';
import img from './tpforlp3.png';
import img2 from './assessmentforlp.png';
import eyerenaKitImg from './eyerenakit.png';
import hartchartlangingpae from './hartchartlandingpage.png';

const HomeRoles = (props) => (
  <Box
    sx={{
      backgroundColor: 'background.paper',
      pt: 15
    }}
    {...props}
  >
    <Container maxWidth="lg">
      <hr />
      <br />
      <br />
      <br />
      <br />
      <Grid
        container
        spacing={6}
      >
        <Grid
          item
          md={12}
          xs={12}
        >
          <Typography
            color="textPrimary"
            variant="h2"
            align="center"
          >
            Visual- und Kognitionstraining – kurz ViCo
            <br />
            <br />
          </Typography>
          <br />
          <Typography
            color="textSecondary"
            variant="h4"
            align="center"
          >
            Visual- und Kognitionstraining ist Training für die Augen und das Gehirn.
            <br />
            Das Ziel: richtig sehen lernen und so eine verbesserte Weiterleitung visueller Reize zu erreichen, damit das Gehirn die gewonnenen Seheindrücke kognitiv bestmöglich verarbeiten kann.
            <br />
            <br />
            Wir vernetzen Vico Trainer und Schüler global auf einer offenen IT-Plattform mit individuellen Möglichkeiten zum Austausch, Spiel und Training, um Sehen, Denken, Handeln nachhaltig zu verbessern und so gezielt zu einer Lösung moderner Probleme im Leben und Lernen beizutragen und Verhaltensauffälligkeiten zu begegnen.
          </Typography>
        </Grid>
      </Grid>
      <br />
      <br />
      <br />
      <br />
      <hr />
      <br />
      <br />
      <br />
      <Grid
        container
        spacing={6}
      >
        <Grid
          item
          md={6}
          xs={12}
        >
          <Typography
            color="textPrimary"
            variant="h2"
          >
            Verwalte Deine Schüler und Übungen mit eyerena, von überall zugreifbar.
          </Typography>
        </Grid>
        <Grid
          item
          md={6}
          xs={12}
        >
          <Card
            sx={{
              alignItems: 'center',
              backgroundColor: 'background.default',
              display: 'flex',
              flexDirection: 'column',
              pt: 3,
              px: 3
            }}
            variant="outlined"
          >
            <Typography
              align="block"
              color="textSecondary"
              sx={{ py: 2 }}
              variant="inherit"
            >
              eyerena bietet dir alles  für den erfolgreichen Einstieg und nachhaltigen Erfolg als Trainer im ViCo Bereich. Bei uns findest Du die Plattform, um Deinen Arbeitsalltag nachhaltig zu vereinfachen und zu digitalisieren. Wir bieten dir attraktive Standards, eine Übungs- und Spielesammlung, die Orientierung schafft und Inspiration liefert für Neues. Eigene Übungen kannst du leicht und schnell erstellen, erweitern, in individuellen Trainingsplänen teilen und den Fortschritt Deiner Schüler erfassen. Verwaltungsaufwand und Ressourcenverbrauch sinken mit uns und Du gewinnst Zeit für deine eigentlichen Kernaufgaben als ViCo Trainer: die Entwicklung deiner Schüler.
              <br />
              <br />
              <br />
            </Typography>
          </Card>
        </Grid>
      </Grid>
      <br />
      <br />
      <br />
      <br />
      <hr />
      <br />
      <br />
      <br />
      <Grid
        container
        spacing={10}
      >
        <Grid
          item
          md={6}
          xs={12}
        >
          <Box>
            <img
              alt="brockschnur"
              src={img}
              style={{
                maxWidth: '100%',
                backgroundSize: 'cover',
                borderRadius: 10,
                zIndex: 20,
                bottom: 0,
                left: 0,
                right: 0,
                top: 50
              }}
            />
          </Box>
        </Grid>
        <Grid
          item
          md={6}
          xs={12}
        >
          <Typography
            color="textPrimary"
            variant="h2"
          >
            Erstelle tolle Trainingspläne für Deine Schüler. In der Trainer Pro Version sogar individualisiert.
          </Typography>
        </Grid>
      </Grid>
      <br />
      <br />
      <br />
      <br />
      <hr />
      <br />
      <br />
      <br />
      <Grid
        container
      >
        <Grid
          item
          md={12}
          xs={12}
          lg={12}
          justifyContent="center"
        >
          <Typography
            color="textPrimary"
            variant="h2"
            align="center"
          >
            Greife auf viele vordefinierte Übungen zu.
          </Typography>
          <br />
          <br />
          <Typography
            color="textSecondary"
            variant="h4"
            align="center"
          >
            Viele spannende Übungen warten auf Dich. Erstelle und verwalte Deine eigenen Übungen. Teile sie mit der Community und genieße besondere Vorteile als zertifizierter eyeTrainer bei uns.
            <br />
            <br />
            Kreiere passend zu Deinen Übungen individuelles ViCo Material.
            <Box>
              <img
                alt="Beispiel ViCo Materina Hart Chart Decoding"
                src={hartchartlangingpae}
                align="center"
                style={{
                  maxWidth: '100%',
                  backgroundSize: 'cover',
                  borderRadius: 10,
                  alignItems: 'center',
                  zIndex: 20,
                  bottom: 0,
                  left: 0,
                  right: 0,
                  top: 40
                }}
              />
            </Box>
          </Typography>
        </Grid>
      </Grid>
      <br />
      <br />
      <br />
      <br />
      <hr />
      <br />
      <br />
      <br />
      <Grid
        container
        spacing={8}
      >
        <Grid
          item
          md={6}
          xs={12}
        >
          <Typography
            color="textPrimary"
            variant="h2"
          >
            Bald verfügbar, Assessments für Schüler mit eyeTracking auf allen Geräten.
          </Typography>
        </Grid>
        <Grid
          item
          md={6}
          xs={12}
        >
          <Box>
            <img
              alt="eyerena start logo"
              src={img2}
              style={{
                maxWidth: '100%',
                backgroundSize: 'cover',
                borderRadius: 10,
                zIndex: 20,
                bottom: 0,
                left: 0,
                right: 0,
                top: 50
              }}
            />
          </Box>
        </Grid>
      </Grid>
      <br />
      <br />
      <br />
      <br />
      <hr />
      <br />
      <br />
      <br />
      <Grid
        container
        spacing={10}
      >
        <Grid
          item
          md={6}
          xs={12}
        >
          <Box>
            <img
              alt="Eyerena Kit for Students"
              src={eyerenaKitImg}
              style={{
                maxWidth: '100%',
                backgroundSize: 'cover',
                borderRadius: 10,
                zIndex: 20,
                bottom: 0,
                left: 0,
                right: 0,
                top: 50
              }}
            />
          </Box>
        </Grid>
        <Grid
          item
          md={6}
          xs={12}
        >
          <Typography
            color="textPrimary"
            variant="h2"
          >
            Pakete für neue Schüler oder Vereine mit allen notwendigen Materialien für den ViCo Start. Passend zu unseren Übungen.
          </Typography>
        </Grid>
      </Grid>
      <br />
      <br />
      <br />
      <br />
      <hr />
      <br />
      <br />
      <br />
      <br />
      <Grid
        container
      >
        <Grid
          item
          md={12}
          xs={12}
        >
          <Typography
            color="textPrimary"
            variant="h2"
            align="center"
          >
            Registriere Dich jetzt kostenlos bei eyerena
          </Typography>
          <br />
          <br />
          <br />
          <Box textAlign="center">
            <Button
              color="primary"
              component="a"
              href="https://eyerena.com/authentication/register"
              size="large"
              target="_blank"
              variant="contained"
            >
              registrieren
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Divider sx={{ pt: 15 }} />
    </Container>
  </Box>
);

export default HomeRoles;
